<template>
  <i class="favicon" v-bind:class="favClass"></i>
</template>
<style>

</style>
<script>
import { mapGetters } from 'vuex'

export default{
  props: [
    'aid',
    'gender'
  ],
  computed: {
    ...mapGetters({
      favourites: 'favourites'
    }),
    favClass: function () {
      return {
        'icon-activated': (this.favourites.indexOf(this.aid) < 0),
        'icon-favourite': (this.favourites.indexOf(this.aid) >= 0),
        gender: true,
        male: this.gender === 'male',
        female: this.gender === 'female'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/favicon.vue